import { Decimal } from "@kase/my-marathon-communication";
import { leadZero } from "./date";

export const formatSeconds = (value: number) =>
    `${Number(String((value / 3600).toFixed(2)))}h`;

// @TODO: find better name
export const formatTotal = (value: number | undefined) => {
    if (!value) {
        return "0";
    }

    const hours = Math.floor(value);
    const minutes = Math.round((value - hours) * 60);

    if (hours && minutes) {
        return `${hours}h ${minutes}m`;
    }

    if (hours) {
        return `${hours}h`;
    }

    return `${minutes}m`;
};

export const formatMinutes = (value: number, lzH = true) => {
    const hours = Math.floor(value / 60);
    const minutes = Math.round(value - hours * 60);

    return `${lzH ? leadZero(hours) : hours}:${leadZero(minutes)}`;
};

export const formatReportedMinutes = (value: number) => {
    const hours = Math.floor(value / 60);
    const minutes = Math.floor(value - hours * 60);

    return `${leadZero(hours)}:${leadZero(minutes)}`;
};

export const decimalToStr = (value: Readonly<Decimal> | null | undefined) =>
    value ? String(parseFloat(value.toString())) : "";

export const randInt = (min = 0, max = 100) =>
    Math.floor(Math.random() * (max - min + 1)) + min;

export const randFloat = (min = 0, max = 1) =>
    Math.random() * (max - min) + min;
